import * as React from 'react';

import { PageTitleBar } from 'components';

const PackagingModelHeader = ({
  children,
}: React.PropsWithChildren<unknown>) => <PageTitleBar headerTitle={children} />;

export { PackagingModelHeader };
